import { $http } from '../request'

export const getFlashSalesConfig = () => 
  $http.get({ url: '/fs-sessions/today', loading: true }).then((r: any) => r.data)

export const getFlashSkus = (id: number, params: any, loading:boolean = true) =>
  $http.get({ url: `/fs-session/${id}/skus`, params, loading }).then((r: any) => r.data)

export const getFlashCategoryById = (id: number) =>
  $http.get({ url: `/flash-sales/${id}/categories`, loading: true }).then((r: any) => r.data)
